import { render, staticRenderFns } from "./page-version.vue?vue&type=template&id=5f55e0e5&scoped=true&"
import script from "./page-version.vue?vue&type=script&lang=js&"
export * from "./page-version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f55e0e5",
  null
  
)

export default component.exports